module.exports = __webpack_public_path__ + "bg-iphone-c9b5044b44ae6be60f6e94b8fe700b59.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/app/img/bg-iphone.jpg
// module id = 662
// module chunks = 0